module.exports = __webpack_public_path__ + "static/media/de.d8277b2a.svg";